<template>
    <o-table :title="$t('core.notifications')" url="/api/system/notifications" ref="tableList" :enable-delete="false" :enable-new="false" :enable-edit="false" default-sort-by="created_at" default-sort-by-direction="desc">
      <template slot="filter">
        <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
          <o-filter-select :items="types" :title="$t('sandoz.type')" column="type"></o-filter-select>
          <o-filter-text :title="$t('sandoz.user')" column="user"></o-filter-text>
          <o-filter-datepicker :title="$t('core.date')" column="created_at"></o-filter-datepicker>
        </o-filter>
      </template>
      <template slot="head">
        <o-table-header column="type">{{$t('sandoz.type')}}</o-table-header>
        <o-table-header :sortable="false">{{$t('core.user')}}</o-table-header>
        <o-table-header :sortable="false">{{$t('core.email')}}</o-table-header>
        <o-table-header column="created_at">{{$t('core.created_at')}}</o-table-header>
      </template>
      <template slot="body" slot-scope="props">
            <td>{{ notificationType(props.item.type) }}</td>
            <td>{{ props.item.notifiable ? props.item.notifiable.name : null }}</td>
            <td v-html="markdown(props.item.data.email)"></td>
            <td>{{ props.item.created_at | formatDatetime }}</td>
      </template>
    </o-table>
  </template>

  <script>
  import axios from 'axios'
  import MarkdownIt, { Options as MarkdownItOptions } from 'markdown-it'

  export default {
    data: () => ({
      md: null,
      types: []
    }),

    mounted () {
        this.getNotificationTypes()
    },

    created() {
        this.md = new MarkdownIt()
        this.md.renderer.rules.table_open = function () {
          return '<table class="table table-sm table-striped">\n';
        }
        this.md.renderer.rules.blockquote_open = function() {
          return '<blockquote class="blockquote">\n';
        }
    },

    methods: {
        getNotificationTypes() {
            let $self = this;
            axios.get(`/api/system/notifications/types`).then((response) => {
                response.data.types.forEach(function (type) {
                    $self.types.push({
                        value: type,
                        text: $self.notificationType(type)
                    })
                })
            })
        },
        notificationType (notification) {
            var narray = notification.split('\\');
            var lastItem = narray.pop();
            return lastItem.replace(/([A-Z])/g, ' $1').trim()
        },
        markdown(value) {
            return (value && typeof value == 'string') ? this.md.render(value) : value
        }
    }

  }
  </script>
